var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 133,
    viewBox: "0 0 375 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.4035 26.4237C49.8798 27.4959 46.1651 25.5047 45.1069 21.9764C44.0483 18.4478 46.0463 14.7184 49.5699 13.6462C53.0933 12.5739 56.8078 14.5652 57.8666 18.0938C58.9251 21.6221 56.9269 25.3517 53.4035 26.4237Z",
    fill: "#FF7A00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M353.864 49.6855C353.889 53.2321 351.041 56.1365 347.502 56.1726C343.963 56.2087 341.075 53.3629 341.05 49.8163C341.025 46.2694 343.872 43.3653 347.411 43.3292C350.95 43.293 353.838 46.1387 353.864 49.6855Z",
    fill: "#F7E6D3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7891 8.10366C20.7703 5.40828 22.9349 3.20073 25.6243 3.17308C28.3134 3.14543 30.5088 5.30812 30.5276 8.00352C30.5464 10.6989 28.3815 12.9065 25.6924 12.9341C23.0031 12.9618 20.8079 10.799 20.7891 8.10366ZM29.7588 8.01143C29.7429 5.7416 27.8943 3.9204 25.6296 3.94368C23.3649 3.96697 21.5421 5.82596 21.5579 8.09576C21.5738 10.3655 23.4223 12.1868 25.687 12.1635C27.9518 12.1402 29.7746 10.2811 29.7588 8.01143Z",
    fill: "#F7E6D3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.44429 62.7099C2.49594 61.5127 -0.534882 56.5181 0.674938 51.5542C1.88476 46.5904 6.87707 43.5369 11.8257 44.7341C16.7743 45.9314 19.8051 50.9259 18.5953 55.89C17.3855 60.8539 12.3928 63.9073 7.44429 62.7099ZM17.8484 55.7094C18.9574 51.1591 16.1792 46.5809 11.6431 45.4833C7.10696 44.3859 2.53076 47.1849 1.4218 51.7352C0.312811 56.2852 3.09101 60.8633 7.62692 61.9607C12.163 63.0584 16.7395 60.2596 17.8484 55.7094Z",
    fill: "#FFDAAF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M363.226 87.0072C358.277 85.81 355.246 80.8155 356.456 75.8516C357.666 70.8877 362.658 67.8343 367.607 69.0315C372.556 70.2287 375.586 75.2233 374.377 80.1874C373.167 85.1513 368.174 88.2047 363.226 87.0072ZM373.63 80.0067C374.739 75.4565 371.96 70.8783 367.424 69.7807C362.888 68.6833 358.312 71.4823 357.203 76.0325C356.094 80.5825 358.872 85.1607 363.408 86.2581C367.944 87.3557 372.521 84.557 373.63 80.0067Z",
    fill: "#FFDAAF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.774 55.9256C65.4213 57.3734 63.9651 58.264 62.5218 57.9147C61.0787 57.5656 60.1945 56.1089 60.5472 54.6611C60.9001 53.2135 62.3563 52.3226 63.7996 52.6717C65.243 53.021 66.1269 54.4777 65.774 55.9256Z",
    fill: "#FF7A00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.316 96.3461C273.308 95.2113 272.384 94.3005 271.251 94.3121C270.118 94.3236 269.207 95.2531 269.215 96.388C269.223 97.5228 270.147 98.4336 271.28 98.422C272.413 98.4104 273.324 97.481 273.316 96.3461Z",
    fill: "#F7E6D3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M369.945 11.6065C369.961 13.8053 368.195 15.6061 366.001 15.6285C363.807 15.6509 362.016 13.8863 362.001 11.6875C361.985 9.48873 363.751 7.68791 365.945 7.66552C368.139 7.64314 369.93 9.40766 369.945 11.6065Z",
    fill: "#FF7A00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0494 38.7561C36.9487 39.3951 34.7341 38.208 34.1032 36.1046C33.4722 34.001 34.6632 31.778 36.7639 31.1385C38.8646 30.4995 41.0789 31.6866 41.7101 33.79C42.3411 35.8936 41.1498 38.1168 39.0494 38.7561Z",
    fill: "#F7E6D3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.401 29.818C290.382 27.1226 292.546 24.9153 295.236 24.8878C297.925 24.8604 300.12 27.0232 300.139 29.7186C300.159 32.414 297.994 34.6214 295.305 34.6488C292.615 34.6763 290.42 32.5133 290.401 29.818ZM299.371 29.7265C299.355 27.4567 297.506 25.6353 295.241 25.6584C292.977 25.6815 291.154 27.5404 291.17 29.8102C291.186 32.0799 293.035 33.9013 295.299 33.8782C297.564 33.8551 299.387 31.9962 299.371 29.7265Z",
    fill: "#F7E6D3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.661 60.4714C306.561 61.1104 304.346 59.9233 303.715 57.8199C303.084 55.7163 304.275 53.4934 306.376 52.8538C308.476 52.2149 310.691 53.4019 311.322 55.5053C311.953 57.609 310.762 59.8321 308.661 60.4714Z",
    fill: "#FF7A00"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 37,
    width: 91,
    height: 88,
    fill: "url(#pattern0)",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: 281,
    y: 37,
    width: 99,
    height: 96,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_0_1",
    transform: "matrix(0.00123011 0 0 0.00130498 -0.352459 -0.00111401)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignal);
export default __webpack_public_path__ + "static/media/signal.e3b2049ba64a8e600e97c3874844f585.svg";
export { ForwardRef as ReactComponent };